import Vue from "vue";
import Vuex from "vuex";
import API from '@/api/material'

Vue.use(Vuex);

const state = {
      theme: "light",						//状态管理器state中的初始theme值设置为light
      themeIdx:0,
      themeArr:[require("@/assets/theme/theme_light.png"),require("@/assets/theme/theme_dark.png")],

      iframeSrc:'',
      iframeTitle: '',
      API_params:{
                    action:'getall'
                  },
      API_params2:{
                    action:'getall_materialTypeNums'
                  },
      API_params3:{
                    action:'getall_boat_id',
                    boat_id:'',
                  },
      // API_params4:{
      //               action:'getall_materialType_id',
      //               materialtype_id:'',
      //             },
      API_params4:{
                    action:'getallbysort',
                  },
      API_params5:{
                    action:'update',
                  },
      AllClass:{},

      eventModuleIds:{
          managemente:1,
          equipment:2,
          qulity:3,
      }
    };
const mutations= {
  // 设置切换主题
  // 设置切换主题
  setTheme(state, theme) {
    state.theme = theme;
    localStorage.setItem("air-conditioner-theme", theme);
    document.head
      .querySelector("#theme-link")
      .setAttribute("href", `./static/style/theme-${theme}.css`);
  },
  //获取缓存主题
  getTheme(state) {
    state.theme = localStorage.getItem("air-conditioner-theme") || "light";
    state.themeIdx = localStorage.getItem("air-conditioner-themeIdx") || 0;
    document.head
      .querySelector("#theme-link")
      .setAttribute("href", `./static/style/theme-${state.theme}.css`);

      
  },
  switch(state){
        state.themeIdx == 0?state.themeIdx = 1:state.themeIdx = 0;
        let theme;
       
        if(state.themeIdx ==0){
            theme = 'light';
            document.getElementById('iframe')
            .contentWindow.postMessage(3, 
                "http://192.168.0.109:8082/")
        }else{
            theme = 'dark';
            document.getElementById('iframe')
            .contentWindow.postMessage(4, 
                "http://192.168.0.109:8082/")
        }
        state.theme = theme;
        localStorage.setItem("air-conditioner-theme", theme);
        localStorage.setItem("air-conditioner-themeIdx", state.themeIdx);
        document.head
      .querySelector("#theme-link")
      .setAttribute("href", `./static/style/theme-${theme}.css`);
  },
  getUniversalClass(state){

      API.getAllMaterialType(state.API_params).then(res=>{
        state.AllClass.AllMaterialType = res.message.obj;
        console.log('store_AllMaterialType',res.message.info);
      }).catch(err=>{
        console.log(err);
      })
      API.getAllShip(state.API_params).then(res=>{
        state.AllClass.AllShip = res.message.obj;
        console.log('store_AllShip',res.message.info);
      }).catch(err=>{
        console.log(err);
      })

    console.log("state.AllClass",state.AllClass);
  }
}


export default new Vuex.Store({
  state,
  mutations
});


